"use strict";

import betaCtrl from "./beta";
import betaV2Ctrl from "./beta-v2";
import heatmapDirective from "./heatmap";
import hourDistributionDirective from "./hour-dist";
import dayHistogramDirective from "./day-hist";
import callChartDirective from "./call-chart";
import { timeFilter } from "./filters";

const MODULE_NAME = "daupler.analytics";

var app = angular.module(MODULE_NAME, ["chart.js"]);

app.controller("AnalyticsBetaCtrl", betaCtrl);
app.controller("AnalyticsBetaV2Ctrl", betaV2Ctrl);
app.directive("dauplerAnalyticsHeatmap", heatmapDirective);
app.directive("dauplerAnalyticsHourDistribution", hourDistributionDirective);
app.directive("dauplerAnalyticsDayHistogram", dayHistogramDirective);
app.directive("dauplerAnalyticsCallChart", callChartDirective);
app.filter("analyticsTime", timeFilter);

export default MODULE_NAME;
